<template>
  <div class="box">
    <div class="head-box">
      <b>日程信息</b> Schedule info
    </div>
    <div v-if="data.length > 0" style="width:1200px;overflow: hidden;margin-bottom:20px;">
      <div class="table-header" >
             <div class="header-list" v-for="(header,index) in header" :key="index">
                 <div class="header-txt" v-if="header.type == 'txt'">{{header.value}}</div>
                 <div class="header-img" v-if="header.type == 'img'"><img :src="header.value" alt="" style="width:100%;height:100%"></div>
             </div>
         </div>
         <div class="table-body">
             <div class="body-list" v-for="(player,index) in data" :key="index">
                 <div class="agency flx-1" style="border-left:1px solid #ccc;">{{player.month}}</div>
                 <div class="region flx-1" >{{player.time}}</div>
                 <div class="region flx-1" >{{player.content}}</div>
                 <div class="region flx-1" >{{player.teach}}</div>
                 <div class="region flx-1" >{{player.address}}</div>
             </div>
         </div>
    </div>
  </div>
</template>

<script>
import Upload from '@comm/upload/Upload'
import matchFun from '@comm/utils/matchFun'
export default {
  name: 'ExaminSchedule',
  components: {
    Upload
  },
  data () {
    return {
      matchFun,
      data: [],
      header: [
        {type: 'txt', value: '日期'},
        {type: 'txt', value: '时间'},
        {type: 'txt', value: '教学内容'},
        {type: 'txt', value: '讲师'},
        {type: 'txt', value: '地点'}
      ]
    }
  },
  created: function () {
    this.findData()
  },
  methods: {
    findData () {
      this.$api.examin.examinScheduleList({pointId: this.$route.query.id}).then(res => {
        if (res.status === 0) {
          this.data = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.box{
  width: 1200px;
  margin: 0 auto;
}
.head-box{
  font-size: 18px;
  color: black;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid rgb(235, 234, 234);
}
.table-header{
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #244e8f;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px 10px 0px 0px;
}
.table-body{
    width: 100%;
    line-height: 50px;
    // background: #B01F24;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}
.header-list{
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color:white;
}
.flx-1{
    flex: 1;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: row;
    overflow: hidden;
    white-space: nowrap;
    border-right:1px solid #ccc;
    border-bottom:1px solid #ccc;
    height: 50px;
}
.body-list{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/ActivitySchedule.vue